import { removeNulls } from 'utils/Object.utils';

type ReducerAction = {
  type?: string;
  [key: string]: any;
};

export type PropertyOwnershipState = Record<string, any>;

const initialState: PropertyOwnershipState = {};

const propertyOwnershipReducer = (
  state: PropertyOwnershipState = initialState,
  action: ReducerAction
): PropertyOwnershipState => {
  switch (action.type) {
    case 'PROPERTY_OWNERSHIP_UPDATE': {
      const { investorId, fraction } = action;
      return {
        ...state,
        [investorId]: fraction,
      };
    }
    case 'PROPERTY_OWNERSHIP_DELETE': {
      const { investorId } = action;
      return removeNulls({
        ...state,
        [investorId]: null,
      }) as PropertyOwnershipState;
    }
    default:
      return state;
  }
};
export default propertyOwnershipReducer;
